import { refs } from '../DOM';

export function makeErrorMassage() {
  refs.inputAnswerParEl.innerHTML =
    'Search result not successful. Enter the correct movie name and repeat';
}
